import module from 'recursoshumanos/module.js'

const schema = {
  id: 'number',
}

export class RecursosHumanosClasePrimaDeRiesgoRegistroPatronalesService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, clasePrimaDeRiesgoId) {
    return this.$http.get('/api/recursos-humanos/clase-prima-de-riesgo/registros-patronales', {
      params: {
        empresaId,
        clasePrimaDeRiesgoId,
      },
      schema
    })
  }
}

module.service('RecursosHumanosClasePrimaDeRiesgoRegistroPatronales', RecursosHumanosClasePrimaDeRiesgoRegistroPatronalesService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/ClasePrimaDeRiesgo/RegistrosPatronales.js